<p class="text-xl mb-4 font-medium mt-10">{{ householdMember().firstName }} {{ householdMember().lastName }}</p>
<div class="flex flex-row gap-8 mb-2">
  <app-labeled label="Sync status" [value]="householdMember().nycData.syncStatus"></app-labeled>
</div>

<p class="text-lg mb-2 font-medium mt-6">Income</p>
<div class="flex flex-row gap-8 mb-2">
  <app-labeled label="Sync status" [value]="householdMember().income.nycData.syncStatus"></app-labeled>
</div>

<p-table [value]="householdMember().income.properties" class="mb-8">
  <ng-template pTemplate="header">
    <tr>
      <th>Type</th>
      <th>Amount</th>
      <th>Sync status</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-income [cTypedTableRow]="householdMember().income.properties">
    <tr>
      <td>{{ income.type }}</td>
      <td>{{ income.value }}</td>
      <td>{{ income.nycData.syncStatus }}</td>
    </tr>
  </ng-template>
</p-table>

<p class="mb-2 text-lg font-medium mt-6">Assets</p>

<div class="flex flex-row gap-8 mb-2">
  <app-labeled label="Sync status" [value]="householdMember().assets.nycData.syncStatus"></app-labeled>
</div>

<p-table [value]="householdMember().assets.properties" class="mb-8">
  <ng-template pTemplate="header">
    <tr>
      <th>Type</th>
      <th>Value</th>
      <th>Sync status</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-asset [cTypedTableRow]="householdMember().assets.properties">
    <tr>
      <td>{{ asset.type }}</td>
      <td>{{ asset.value }}</td>
      <td>{{ asset.nycData.syncStatus }}</td>
    </tr>
  </ng-template>
</p-table>
